import { cn } from "@/lib/utils";

export type ControlSize = "sm" | "md";

/** Gemensam höjd på alla priskontroller så de radar upp sig snyggt */
export const controlHeight: Record<ControlSize, string> = {
  // Större tryckytor på mobil (minst ~44px totalhöjd), kompaktare från sm och uppåt
  sm: "h-11 sm:h-9",
  md: "h-12 sm:h-10",
};

/** Ytterhölje för en segmenterad växlare (Enkel/Avancerad, Kvarts/Tim, moms) */
export const segmentedContainer = (size: ControlSize = "md", className?: string) =>
  cn(
    "inline-flex items-center rounded-lg border border-border bg-background p-1",
    controlHeight[size],
    className,
  );

/** Enskild knapp i en segmenterad växlare */
export const segmentedButton = (
  active: boolean,
  size: ControlSize = "md",
  className?: string,
) =>
  cn(
    "inline-flex h-full items-center justify-center gap-1.5 rounded-md font-medium transition-colors whitespace-nowrap",
    size === "sm" ? "px-3 text-xs" : "px-4 text-sm",
    active
      ? "bg-primary text-primary-foreground"
      : "text-muted-foreground hover:text-foreground hover:bg-muted",
    className,
  );
